import { getBracketNumberOfRounds } from './bracketSize'
import { generateRounds } from './generateRounds'
import {
  type WithGameParticipantId,
  type BracketRound,
  fillRoundsWithMatches,
  SEEDING_ROUND,
  isDefined,
} from '@terros/common'

const randomizeParticipants = (participants: WithGameParticipantId[]): WithGameParticipantId[] => {
  return participants.sort(() => Math.random() - 0.5)
}

export const toNewRandomizedRounds = (
  currentRounds: BracketRound[],
  newParticipants: WithGameParticipantId[]
): BracketRound[] => {
  const currentNumberOfRounds = currentRounds.length
  const newNumberOfRounds = getBracketNumberOfRounds(newParticipants.length)

  const roundsToAdd = newNumberOfRounds - currentNumberOfRounds

  const currentTimeBetweenRounds =
    currentRounds.length === 1 ? 0 : currentRounds[1].startDate - currentRounds[0].endDate
  const lastRoundSettings = currentRounds[currentRounds.length - 1]
  const lastRoundDuration = lastRoundSettings.endDate - lastRoundSettings.startDate
  const randomizedParticipants = randomizeParticipants(newParticipants)

  if (roundsToAdd < 0) {
    const seedingRound = currentRounds.find((r) => r.round === SEEDING_ROUND)
    const seedingRoundDuration = isDefined(seedingRound) ? seedingRound.endDate - seedingRound.startDate : undefined
    const rounds = generateRounds({
      startDate: currentRounds[0].startDate,
      bracketParticipantsCount: newParticipants.length,
      roundDuration: lastRoundDuration,
      timeBetweenRounds: currentTimeBetweenRounds,
      seedingRoundDuration,
    })
    return fillRoundsWithMatches(rounds, randomizedParticipants)
  }
  if (roundsToAdd > 0) {
    const newRounds = Array.from({ length: roundsToAdd }, (_, index) => {
      const roundStartDate =
        currentRounds[currentRounds.length - 1].endDate + index * (lastRoundDuration + currentTimeBetweenRounds)
      return {
        round: currentNumberOfRounds + index + 1,
        startDate: roundStartDate,
        endDate: roundStartDate + lastRoundDuration,
        matches: [],
      }
    })

    currentRounds.push(...newRounds)
  }
  return fillRoundsWithMatches(currentRounds, randomizedParticipants)
}
